import { render, staticRenderFns } from "./WorkspaceFoldersDocuments.vue?vue&type=template&id=56d07948&"
import script from "./WorkspaceFoldersDocuments.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFoldersDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports